import * as React from "react";
import {
  Grid,
  FormControl,
  FormGroup,
  FormControlLabel,
  Checkbox,
  FormLabel,
} from "@mui/material";

export interface Props {
  label: string;
  selectedDisplayValues: any[];
  selectedStateValues: any[];
  selectedInsuranceFunds: any[];
  selectedCharterTypes: any[];
  selectedTransactionTypes: any[];
  choices: FormSelectChoice[];
  onAdd: (
    changed: any[],
    currentReport: string,
    filterField?: string,
    updateReport?: boolean,
  ) => void;
  onRemove: (
    changed: any[],
    currentReport?: string,
    filterField?: string,
    updateReport?: boolean,
  ) => void;
  currentReport: string;
  filterField?: string;
  updateReport?: boolean;
}

interface FormSelectChoice {
  label: string;
  value: any;
  checked?: boolean;
}

function SelectSection({
  label,
  selectedDisplayValues,
  selectedStateValues,
  selectedInsuranceFunds,
  selectedCharterTypes,
  selectedTransactionTypes,
  choices,
  onAdd,
  onRemove,
  currentReport,
  filterField,
  updateReport,
}: Props) {
  selectedDisplayValues = selectedDisplayValues.filter(item => {
    return item !== "";
  });

  function getSelectedValues() {
    const fieldValues: any = {
      selectedStates: selectedStateValues,
      selectedStatesAlpha: selectedStateValues,
      selectedInsuranceFunds: selectedInsuranceFunds,
      selectedCharterTypes: selectedCharterTypes,
      selectedTransactionTypes: selectedTransactionTypes,
    };

    return filterField ? fieldValues[filterField] : selectedDisplayValues;
  }

  const selectedAll = choices.every(
    (choice: FormSelectChoice) => choice.checked,
  );
  const selectAllLabel = `${label}_Select All / None`;
  const allValues = choices.map((choice: any) => {
    return choice.value;
  });

  const selectAllChoice = {
    label: "Select All / None",
    value: selectAllLabel,
    checked: selectedAll,
  };
  const choiceChanged = (event: any) => {
    if (event.target.checked) {
      if (event.target.value === selectAllLabel) {
        onAdd(allValues, currentReport, filterField, updateReport);
      } else {
        onAdd(
          [
            isNaN(event.target.value)
              ? event.target.value
              : parseInt(event.target.value),
          ],
          currentReport,
          filterField,
          updateReport,
        );
      }
    } else {
      if (event.target.value === selectAllLabel) {
        onRemove(allValues, currentReport, filterField, updateReport);
      } else {
        onRemove(
          [
            isNaN(event.target.value)
              ? event.target.value
              : parseInt(event.target.value),
          ],
          currentReport,
          filterField,
          updateReport,
        );
      }
    }
  };

  const allChoices = [
    selectAllChoice,
    ...choices.map((c: any) => {
      c.checked = getSelectedValues()
        ? getSelectedValues().indexOf(c.value) > -1
        : false;
      return c;
    }),
  ];

  // TODO: Want to make this uniform with the other checkbox component (<Choice /> in ./SubSectionFields.tsx) used in Historical App.
  // ChoiceList does not allow for class to be applied to root <div> or for size adjustment on Checkbox type
  const val = (
    <Grid container justifyContent="space-around">
      <Grid item>
        <FormControl component="fieldset">
          <FormLabel
            component="legend"
            style={{
              height: 1,
              margin: -1,
              display: "block",
              overflow: "hidden",
              padding: 0,
              position: "absolute",
              width: 1,
            }}
          >
            {label}
          </FormLabel>
          <FormGroup>
            {allChoices.map((choice: any, index: number) => {
              // ID prop to allow searching for input selection
              const id = choice.label
                .replace(/[^a-zA-Z ]/g, "")
                .replace(/\s\s+/g, " ")
                .replace(/\s/g, "-")
                .toLowerCase();
              const labelId = `${id}-${index}-label`;

              return (
                <FormControlLabel
                  key={labelId}
                  id={labelId}
                  control={
                    <Checkbox
                      onClick={choiceChanged}
                      color="primary"
                      checked={choice.checked}
                      inputProps={{
                        "aria-labelledby": labelId,
                        "id": `${id}-${choice.checked}`,
                      }}
                      value={choice.value}
                      id={id}
                    />
                  }
                  label={choice.label}
                />
              );
            })}
          </FormGroup>
        </FormControl>
      </Grid>
    </Grid>
  );

  return val;
}

export default SelectSection;
